































































import {Component, Vue} from "vue-property-decorator"
import {vxm} from "@/store"
import Gravatar from "@/components/Gravatar.vue"
import {FlushMessageType, User} from "@/interface"

@Component({components: {Gravatar}})
export default class AdminUserEdit extends Vue {

  private user: User | null = null

  private given_name: string = ""
  private family_name: string = ""
  private email: string = ""
  private role: string = ""
  private domains: string[] = []

  private loading: boolean = false

  get sites() {
    return vxm.site.sites
  }

  async mounted() {
    await vxm.user.fetchUsers()
    await vxm.site.fetchSites()
    this.user = vxm.user.users.find(user => user.sub === this.$route.params.id) || null
    if (this.user) {
      this.given_name = this.user.given_name
      this.family_name = this.user.family_name
      this.email = this.user.email
      this.role = this.user.role || ""
      this.domains = this.user.domains || []
    }
  }

  async onSave() {
    if (this.user) {
      try {
        this.loading = true
        await vxm.user.updateUser({
          sub        : this.user.sub,
          email      : this.email,
          given_name : this.given_name,
          family_name: this.family_name,
          role       : this.role,
          domains    : this.domains
        })
        vxm.app.addFlushMessage({
          type   : FlushMessageType.SUCCESS,
          message: "User edit successful"
        })
      } catch (e) {
        console.error(e)
        vxm.app.addFlushMessage({
          type   : FlushMessageType.ERROR,
          message: "An error has occurred"
        })
      } finally {
        this.loading = false
      }
    }
  }
}
